import './Card.css';const card = "_card_9fpd6_1";
const styles = {
  card
};
export {
  card,
  styles as default
};
